import React, { useEffect, useState } from "react";
import TitleBtnFragment from "../../../components/fragment/title-btn/TitleBtnFragment";
import "../../../styles/dashboard/roles/RolesIndex.css";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import {
  RazorCheckBox,
  RazorInputField,
} from "../../../components/razor-reuse";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { useDispatch, useSelector } from "react-redux";
import RootState from "../../../redux/type";
import { getModulePermissions, getSingleRole } from "../../../redux/role";
import {
  capitalizeFirstLetter,
  getTruePermissions,
  SPECIAL_ROLES,
} from "../../../utils/Helper";

const ViewRoleIndex = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [roleInfo, setRoleInfo] = useState<any>({});
  const { loading, loading_modules, module_permission } = useSelector(
    (state: RootState) => state.roles
  );

  const { user } = useSelector((state: RootState) => state.auth);

  type detailProps = {
    name: string;
    permissions: string[];
    users: string[];
    description: string;
  };
  const [details, setDetails] = useState<detailProps>({
    name: "",
    permissions: [],
    users: [],
    description: "",
  });

  useEffect(() => {
    if (module_permission?.length < 1) {
      dispatch(getModulePermissions({}) as any);
    }
  }, [dispatch, module_permission?.length]);

  const addLabelValue = (list?: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => {
        return { ...chi, label: chi?.username, value: chi?.id };
      });
      return newList;
    }
  };

  const getRoleDetails = React.useCallback(
    async (param: any) => {
      const obj = {
        id: param,
      };
      const data = await dispatch(getSingleRole(obj) as any);

      if (data?.payload?.data?.status) {
        // console.log(data?.payload?.data?.data);
        const obj = data?.payload?.data?.data;
        setRoleInfo(obj);
        setDetails((prev) => {
          return {
            ...prev,
            name: obj?.role?.replaceAll("_", " "),
            description: obj?.description,
            permissions: getTruePermissions(obj?.defined_permissions),
            users: addLabelValue(obj?.users),
          };
        });
      }
    },
    [dispatch]
  );

  useEffect(() => {
    const id = localStorage?.getItem("roleKey") || "";
    if (id) {
      getRoleDetails(id);
    } else {
      navigate(ALL_ROUTES?.DASHBOARD_ROLES);
    }
  }, [getRoleDetails, navigate]);

  return (
    <>
      <DashboardLayoutMain
        loading={loading_modules || loading}
        title="Role Overview"
        back
      >
        {/* add new role index wrap start */}
        <div className="add-new-role-index-wrap-smart-send-box">
          <div className="form-box">
            {/* title fragment start */}
            <TitleBtnFragment
              className="title-btn"
              //   hideBtn
              //   title="Role Overview"
              btnLabel={"Edit Role"}
              hideBtn={
                (details?.name && SPECIAL_ROLES?.includes(roleInfo?.role)) ||
                !user?.permissions?.includes("edit_roles")
                  ? true
                  : false
              }
              sticky
              hideicon
              //   icon={ALL_ICONS?.edit}
              onBtnClick={() => {
                navigate(ALL_ROUTES?.DASHBOARD_ROLES_EDIT);
              }}
            />
            {/* title fragment end */}
            {/* two form group start */}
            <div className="two-form-group-box">
              <RazorInputField
                color="black-light"
                placeholder="Enter role name"
                label="Role Name"
                name="name"
                value={capitalizeFirstLetter(details?.name)}
                capitalize
                disabled
              />
            </div>
            <RazorInputField
              color="black-light"
              placeholder="Select user"
              label="Users"
              type="select"
              multi
              value={details?.users}
              disabled
            />
            {/* two form group end */}
            <RazorInputField
              color="black-light"
              type="textarea"
              label="Description"
              name="description"
              value={details?.description}
              capitalize
              disabled
              onChange={() => {}}
              placeholder="Enter Description"
            />

            <div className="role-permission-wrap-box">
              <p className="header-title">Defined Permissions:</p>

              {/* module permissions box wrap start */}
              <div className="module-permissions-box-wrap">
                {module_permission?.map((chi: any, idx: any) => {
                  return (
                    <div key={idx} className="module-permissions-box">
                      <p
                        style={{ textTransform: "capitalize" }}
                        className="module-name"
                      >
                        {chi?.category}
                      </p>
                      {/* permissions box wrap start */}
                      <div className="permission-box-wrap">
                        {chi?.permissions?.map((child: any, i: any) => {
                          return (
                            <div key={`${idx}-${i}`} className="permission-box">
                              <p
                                style={{ textTransform: "capitalize" }}
                                className="name"
                              >
                                {/*child?.name
                                  ?.replaceAll("_", " ")
                                  ?.includes("users")
                                  ? child?.name
                                      ?.replaceAll("_", " ")
                                      ?.replaceAll("users", "Team Member")
                                  : child?.name
                                      ?.replaceAll("_", " ")
                                      ?.includes("customer")
                                  ? child?.name
                                      ?.replaceAll("_", " ")
                                      ?.replaceAll("customer", "User")
                                  : changeUsersToTeamMember(
                                      child?.name?.replaceAll("_", " ")
                                    )*/}
                                {child?.name}
                              </p>
                              <RazorCheckBox
                                checked={details?.permissions?.includes(
                                  child?.name
                                )}
                                onChange={() => {
                                  // handleAddToList(child?.name);
                                }}
                                id={`${idx}-${i}-${child?.name}` as any}
                                color="black-light"
                                key={`${idx}-${i}-${child?.name}` as any}
                              />
                            </div>
                          );
                        })}
                      </div>
                      {/* permissions box wrap end */}
                    </div>
                  );
                })}
              </div>
              {/* module permissions box wrap end */}
            </div>
          </div>
          {/* form box end */}
        </div>
        {/* add new role index wrap end */}
      </DashboardLayoutMain>
    </>
  );
};

export default ViewRoleIndex;
